/* eslint-disable import/no-cycle */
/* eslint-disable react/destructuring-assignment */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { TagERP, TagType } from "@finanedi.es/storybook"
import {
  faCircleCheck,
  faClock,
  faNoteSticky,
} from "@fortawesome/pro-light-svg-icons"
import { FacturaRecurrenteReadingFiltersDtoProps } from "api/DTOs/FacturaRecurrenteReadingFiltersDto"
import { FlujoTesoreriaReadingFiltersDtoProps } from "api/DTOs/FlujoTesoreriaReadingFiltersDto"
import {
  DOCUMENTO_RECURRENTE_ESTADO,
  DocumentoRecurrenteEstadoType,
} from "api/Types/DocumentoRecurrenteEstado"
import { ESTADO_CUENTA } from "api/Types/EstadoCuentaBancaria"
import { TIPO_FLUJO_TESORERIA } from "api/Types/TipoFlujoTesoreria"
import {
  ESTADO_FACTURAS_RECURRENTES_PROPERTIES,
  ESTADO_PRESTAMOS,
  ESTADO_REVISION_PROPERTIES,
  ESTADO_TIPO_PRESTAMOS,
} from "common/utils/constants"
import { formatNumber } from "common/utils/currency"
import { formatDate } from "common/utils/date"
import { TIPO_DOCUMENTO } from "common/utils/documentos"
import { formatSerieAndNumero } from "common/utils/formats"
import { DEFAULT_CURRENCY_SYMBOL } from "features/Contactos/constants/index"
import { PAYMENT_TYPE_CARTERA_ACTION_SETTINGS } from "features/Tesoreria/pages/Cartera/constants"
import { t } from "i18next"
import { Button } from "primereact/button"
import { useTranslation } from "react-i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendNumber } from "utils/frontendNumber"
import EstadoDocumento from "../../../common/components/EstadoDocumento/EstadoDocumento"
import DocumentosActions from "../components/DocumentosActions"
import NumeroArchivosAdjuntos from "../components/NumeroArchivosAdjuntos"
import { TIPOS_DOCUMENTO } from "../constants"
import {
  FechasRecurrentesKeys,
  INTERVALOS_KEYS,
} from "../pages/FacturasRecurrentes/pages/FacturasRecurrentesDetail/constants"

export const FechaBodyTemplate = (
  rowData: $TSMigrationFixMe,
  className: $TSMigrationFixMe,
  format: $TSMigrationFixMe,
  onClick?: $TSMigrationFixMe
) => {
  const date = rowData?.fechaEmision || rowData?.fecha
  return (
    <span
      className={className}
      onClick={() => onClick?.(rowData)}
    >
      {formatDate(date, format)}
    </span>
  )
}

export const TipoRemesaTemplate = (
  rowData: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  return (
    <span>
      {PAYMENT_TYPE_CARTERA_ACTION_SETTINGS(t)[rowData?.tipo]?.title || ""}
    </span>
  )
}

export const ImporteBodyTemplate = ({
  importe = "",
  divisa = "",
  showDivisaSymbol = true,
  className = "",
}: {
  importe?: number | string
  divisa?: string
  showDivisaSymbol?: boolean
  className?: string
}) => {
  const totalDocumentImport = `${formatNumber(importe)}
  ${showDivisaSymbol ? `${divisa || DEFAULT_CURRENCY_SYMBOL}` : ""}`
  return <span className={className}>{totalDocumentImport}</span>
}

export const ImporteBodyTemplateTesoreria = ({
  importe = "",
  divisa = "",
  showDivisaSymbol = true,
  className = "",
  saldoActual,
}: {
  importe?: number | string
  divisa?: string
  showDivisaSymbol?: boolean
  saldoActual?: number
  className?: string
}) => {
  const { t } = useTranslation()
  const formatSaldoDisponible = `${formatNumber(importe)}
  ${showDivisaSymbol ? `${divisa || DEFAULT_CURRENCY_SYMBOL}` : ""}`

  const hasSaldoActual = Number.isFinite(saldoActual)
  const formatSaldoActual =
    saldoActual && hasSaldoActual
      ? `${frontendNumber(saldoActual)}
    ${showDivisaSymbol ? `${divisa || DEFAULT_CURRENCY_SYMBOL}` : ""}`
      : "-"
  return (
    <div className='tw-flex tw-flex-col tw-justify-center tw-w-full tw-bg-neutral-10 tw-rounded-md tw-py-2 tw-h-21'>
      <p className='tw-text-sm'>{t("bancos.bankCard.labelAvailableBalance")}</p>
      <p className={`${className} tw-text-xl 2xl:tw-font-medium`}>
        {formatSaldoDisponible}
      </p>
      {saldoActual !== 0 && (
        <p className='tw-text-sm'>
          {t("bancos.bankCard.labelCurrentBalance")} {formatSaldoActual}
        </p>
      )}
    </div>
  )
}

export const TipoDocumentoBodyTemplate = ({ tipo = "" }) => {
  return (
    <strong className={tipo === TIPOS_DOCUMENTO["1"] ? "font-color-green" : ""}>
      {tipo}
    </strong>
  )
}

export const NumFacturaBodyTemplate = ({
  serie,
  numero,
  className,
  onClick,
}: $TSMigrationFixMe) => {
  return serie || numero ? (
    <span
      className={className || ""}
      onClick={onClick && onClick}
    >
      {formatSerieAndNumero({ serie, numero })}
    </span>
  ) : (
    <span>---</span>
  )
}

export const TipoEstadoMultiselectBodyTemplate = ({
  label,
  value,
}: $TSMigrationFixMe) => {
  return (
    <div className={`estado-estudio-${value}`}>
      <div className='ellipsis'>{label}</div>
    </div>
  )
}

export const ClienteBodyTemplate = (rowData: $TSMigrationFixMe) => {
  const { cliente } = rowData
  return cliente
}

export const CIFBodyTemplate = (rowData: $TSMigrationFixMe) => {
  const { cif, nif } = rowData
  if (cif) {
    return cif
  }
  if (nif) {
    return nif
  }
}

export const EstadosBodyTemplate = (
  { estadoRevisionActual = 1, ...data },
  t: $TSMigrationFixMe
) => {
  const { backgroundColor, color, text } =
    ESTADO_REVISION_PROPERTIES(t)[estadoRevisionActual] || {}

  return (
    <>
      <EstadoDocumento
        key={data.id}
        id={data.id}
        backgroundColor={backgroundColor}
        color={color}
        text={text}
        motivo={data.motivo}
      />
    </>
  )
}

export const NumeroArchivosAdjuntosTemplate = ({
  rowData,
}: $TSMigrationFixMe) => {
  const { numeroFicherosAdjuntos } = rowData

  return <NumeroArchivosAdjuntos num={numeroFicherosAdjuntos} />
}

export const ActionsFacturaBodyTemplate = ({ rowData }: $TSMigrationFixMe) => (
  <DocumentosActions
    rowData={rowData}
    cesionActive
    title='factura'
    labelXML='Factura electrónica'
    tipoDocumento={TIPO_DOCUMENTO.FACTURA}
  />
)

export const ActionsPedidoBodyTemplate = (
  { rowData }: $TSMigrationFixMe,
  tabSelected: $TSMigrationFixMe
) => (
  <DocumentosActions
    rowData={rowData}
    title='pedido'
    tipoDocumento={TIPO_DOCUMENTO.PEDIDO}
    className='border-0'
    tabSelected={tabSelected}
    isConvertir
  />
)

export const ActionsAlbaranBodyTemplate = (
  { rowData }: $TSMigrationFixMe,
  tabSelected: $TSMigrationFixMe
) => (
  <DocumentosActions
    rowData={rowData}
    title='albarán'
    tipoDocumento={TIPO_DOCUMENTO.ALBARAN}
    className='border-0'
    tabSelected={tabSelected}
    isConvertir
  />
)

export const EstadoFacturaRecurrente = (
  estadoRevisionActual: DocumentoRecurrenteEstadoType,
  id?: string
) => {
  const ESTADO_REVISION_PROPERTIES: Record<
    DocumentoRecurrenteEstadoType,
    {
      icon: React.ReactNode
      color: TagType
      text: string
    }
  > = {
    [DOCUMENTO_RECURRENTE_ESTADO.EN_CURSO]: {
      icon: <FontAwesomeIcon icon={faClock} />,
      color: "info",
      text: t("documentos.facturaRec.tab.inProgressLabel"),
    },
    [DOCUMENTO_RECURRENTE_ESTADO.FINALIZADO]: {
      icon: <FontAwesomeIcon icon={faCircleCheck} />,
      color: "success",
      text: t("documentos.facturaRec.tab.finalLabel"),
    },
  }
  const { icon, color, text } =
    (estadoRevisionActual &&
      ESTADO_REVISION_PROPERTIES[estadoRevisionActual]) ||
    {}

  return (
    <div className='tw-flex tw-justify-center tw-items-center !tw-w-full'>
      <TagERP
        id={id}
        value={text}
        color={color}
        icon={icon}
      />
    </div>
  )
}
export const EstadosFacturaRecurrenteBodyTemplate = (
  { estado = 1, ...data },
  t: $TSMigrationFixMe
) => {
  const { backgroundColor, color, text } =
    ESTADO_FACTURAS_RECURRENTES_PROPERTIES(t)[estado] || {}

  return (
    <>
      <EstadoDocumento
        key={data.id}
        id={data.id}
        backgroundColor={backgroundColor}
        color={color}
        text={text}
        motivo={data.motivo}
      />
    </>
  )
}

export const CuentaContableTemplate = (rowData: $TSMigrationFixMe) => {
  const { cuentaContable, cuenta } = rowData
  return (
    <span className='tw-text-sm tw-font-medium'>
      {cuentaContable || cuenta}
    </span>
  )
}

export const IntervalosRecurrentesTemplate = (
  rowData: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  const { intervalo } = rowData
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
  return <span>{intervalo ? INTERVALOS_KEYS(t)[intervalo].label : ""}</span>
}

export const FechaRecurrentesTemplate = (
  rowData: FacturaRecurrenteReadingFiltersDtoProps,
  key: FechasRecurrentesKeys
) => {
  return <span>{rowData[key] ? formatDate(rowData[key]) : "-"}</span>
}

export const ConciliacionesImporteTemplate = ({
  importe,
  tipo,
}: FlujoTesoreriaReadingFiltersDtoProps) => {
  const signedNumber =
    tipo === TIPO_FLUJO_TESORERIA.COBRO
      ? Math.abs(importe ?? 0)
      : Math.abs(importe ?? 0) * -1

  return (
    <span
      className={
        tipo === TIPO_FLUJO_TESORERIA.COBRO
          ? "tw-text-secondary"
          : "tw-text-danger"
      }
    >
      {frontendCurrency(signedNumber)}
    </span>
  )
}

export const EstadosBodyPrestamosTemplateFilter = ({
  estado,
  t,
}: $TSMigrationFixMe) => {
  const { twBackoundColor, twColor, text } = ESTADO_PRESTAMOS(t)[estado] || {}

  return (
    <div
      className={`${twColor} ${twBackoundColor} tw-items-center tw-mb-0 tw-py-1 tw-px-2 tw-rounded-md tw-font-medium`}
    >
      {text}
    </div>
  )
}

export const EstadosTipoPrestamo = ({
  estado,
  className,
  t,
  ...data
}: $TSMigrationFixMe) => {
  const { backgroundColor, color, text } =
    ESTADO_TIPO_PRESTAMOS(t)[estado] || {}

  return (
    <EstadoDocumento
      key={data.id}
      id={data.id}
      backgroundColor={backgroundColor}
      color={color}
      text={text?.toUpperCase()}
      motivo={data.motivo}
      width='100%'
      fontSize='14px'
      className={className}
    />
  )
}

export const warningBodyTemplate = (
  elemento: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  let msgError = ""

  const isErrorState = (estado: $TSMigrationFixMe) =>
    estado === ESTADO_CUENTA.ERROR ||
    estado === ESTADO_CUENTA.EXPIRED ||
    estado === ESTADO_CUENTA.SUSPENDED

  if (
    isErrorState(elemento.estadoAutorizacionCuenta) &&
    elemento?.balanceDescuadrado
  ) {
    msgError += `${t("errors.conexionBankFail")} \n${t(
      "errors.descuadreBalance"
    )} `
  } else if (isErrorState(elemento.estadoAutorizacionCuenta)) {
    msgError += `${t("errors.conexionBankFail")}`
  } else if (elemento?.balanceDescuadrado) {
    msgError += `${t("errors.descuadreBalance")}`
  }

  return (
    msgError !== "" && (
      <Button
        tooltip={msgError}
        className='!tw-w-6 !tw-h-fit !tw-border-none !tw-bg-transparent !tw-p-0'
        tooltipOptions={{
          position: "bottom",
          mouseTrack: true,
          mouseTrackTop: 15,
        }}
      >
        <FontAwesomeIcon
          icon={["fal", "triangle-exclamation"]}
          className='tw-w-6 tw-h-6 !tw-text-warning'
        />
      </Button>
    )
  )
}

export const ImageBodyTemplate = ({
  concepto,
  src,
  warning,
  t,
  isDefaultLogo = false,
}: $TSMigrationFixMe) => (
  <div className='tw-flex tw-justify-center tw-flex-row tw-items-center'>
    {warning?.balanceDescuadrado && (
      <div className='tw-w-6 tw-mr-2'>{warningBodyTemplate(warning, t)}</div>
    )}
    <img
      className={`${
        isDefaultLogo
          ? "tw-w-auto tw-h-10 tw-object-contain"
          : "tw-h-10 tw-scale-150"
      }`}
      src={src}
      alt={`Imagen de ${concepto}`}
    />
  </div>
)

export const IconAnnotationTemplate = (
  rowData: $TSMigrationFixMe,
  style: $TSMigrationFixMe,
  isView: $TSMigrationFixMe,
  callbackAction: $TSMigrationFixMe
) => {
  return (
    isView && (
      <FontAwesomeIcon
        onClick={() => {
          callbackAction?.(rowData)
        }}
        icon={faNoteSticky}
        className={`tw-cursor-pointer tw-font-bold tw-h-5 tw-w-5 ${
          style && "tw-text-alternative"
        }`}
      />
    )
  )
}

export const IdentificadorBodyTemplate = ({
  identificador,
}: $TSMigrationFixMe) => {
  return <span>{identificador || ""}</span>
}

export const DocumentosActionLabel = ({
  icon,
  title,
  description,
  className,
}: $TSMigrationFixMe) => (
  <div className='tw-flex'>
    <div className='tw-text-primary tw-flex tw-justify-center tw-items-center'>
      <FontAwesomeIcon
        icon={icon}
        className={className}
      />
    </div>
    <div className='tw-flex tw-justify-center tw-items-center'>
      <div className=' tw-text-text-50 tw-text-sm tw-flex tw-flex-col tw-ml-1'>
        {title && (
          <span className='tw-text-primary tw-text-lg tw-font-normal'>
            {title}
          </span>
        )}
        {description && <span>{description}</span>}
      </div>
    </div>
  </div>
)

export const getDocumentosActionLabel = (
  title: $TSMigrationFixMe,
  icon: $TSMigrationFixMe
) => {
  return (
    <DocumentosActionLabel
      className='px-1 icon-convertir'
      title={title}
      icon={["fal", icon]}
    />
  )
}
